//@ts-check
import React, {Component} from 'react';
import {func, shape} from 'prop-types';
import {generalSettingsShape} from './General';
import classNames from 'classnames';
import ImageUploader from 'components/ImageUploader';
import {default as TextInput} from '@sinclair-digital/sbg-storyline-components/src/components/forms/TextInput';
import {default as Textarea} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Textarea';
import {default as Select} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Select';
import {default as Option} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Option';
import {default as Field} from '@sinclair-digital/sbg-storyline-components/src/components/Field';
import data from '@sinclair-digital/stl-common/src/models/domainData';
import styles from './GeneralSettings.scss';

class GeneralSettings extends Component {
    static propTypes = {
        generalSettings: shape(generalSettingsShape),
        onImageUpload: func.isRequired,
        onChange: func.isRequired,
        onUrlChange: func.isRequired,
        onProdUrlBlur: func.isRequired,
        onValidatedInputChange: func.isRequired,
    };

    render() {
        const {
            name,
            city,
            state,
            zipcode,
            url,
            callLetters,
            timezone,
            designatedMarketArea,
            channel,
            network,
            stagingUrl,
            imageUrl,
            footerText,
        } = this.props.generalSettings;
        return (
            <div className={styles.GeneralSettings}>
                <div className={styles.columnLeft}>
                    {/* PROPERTY NAME  */}
                    <Field label="Property Name">
                        <TextInput
                            errorMessage={name.errorMessage}
                            className="sda-input-text-full"
                            name="name"
                            maxLength="256"
                            onChange={this.props.onValidatedInputChange}
                            placeholder="WBFF News"
                            value={name.value}
                            type="text"
                        />
                    </Field>

                    <div className={styles.inputGroupWrapper}>
                        <div className={styles.city}>
                            {/* CITY */}
                            <Field label="City">
                                <TextInput
                                    errorMessage={city.errorMessage}
                                    name="city"
                                    type="text"
                                    className="sda-input-text-full"
                                    value={city.value}
                                    onChange={this.props.onValidatedInputChange}
                                    maxLength="256"
                                    placeholder="Anytown"
                                />
                            </Field>
                        </div>

                        <div>
                            {/* STATE  */}
                            <Field label="State">
                                <div className="sda-select-firefox fa-angle-down">
                                    <Select name="state" onChange={this.props.onChange} value={state}>
                                        {data.usStates.map(st => (
                                            <Option
                                                label={st.abbreviation}
                                                value={st.abbreviation}
                                                key={st.abbreviation}
                                            />
                                        ))}
                                    </Select>
                                </div>
                            </Field>
                        </div>
                    </div>

                    {/* ZIP */}
                    <div className={styles.inputGroupWrapper}>
                        <div className={classNames(styles.triplet, styles.innerWrap)}>
                            <Field label="Weather Zip Code">
                                <TextInput
                                    errorMessage={zipcode.errorMessage}
                                    name="zipcode"
                                    type="text"
                                    className="sda-input-text-full"
                                    value={zipcode.value}
                                    onChange={this.props.onValidatedInputChange}
                                    maxLength="5"
                                    placeholder="11111"
                                />
                            </Field>
                        </div>

                        <div className={classNames(styles.triplet, styles.middle, styles.innerWrap)}>
                            {/* NETWORK */}
                            <Field label="Network">
                                <div className="sda-select-firefox fa-angle-down">
                                    <Select value={network} onChange={this.props.onChange} name="network">
                                        {data.propertyNetworks.map(netwk => (
                                            <Option key={netwk.name} value={netwk.name} label={netwk.name} />
                                        ))}
                                    </Select>
                                </div>
                            </Field>
                        </div>

                        <div className={classNames(styles.triplet, styles.innerWrap)}>
                            {/* CALL LETTERS  */}
                            <Field label="Call Letters">
                                <TextInput
                                    errorMessage={callLetters.errorMessage}
                                    name="callLetters"
                                    type="text"
                                    className="sda-input-text-full"
                                    value={callLetters.value}
                                    maxLength="10"
                                    placeholder="WBFF"
                                    onChange={this.props.onValidatedInputChange}
                                />
                            </Field>
                        </div>
                    </div>

                    {/* TIME ZONE  */}
                    <Field label="Time Zone">
                        <div className="sda-select-firefox fa-angle-down">
                            <Select name="timezone" onChange={this.props.onChange} value={timezone}>
                                {data.usTimeZones.map(({shortName, longName}) => (
                                    <Option key={shortName} label={longName} value={shortName} />
                                ))}
                            </Select>
                        </div>
                    </Field>

                    <div className={styles.inputGroupWrapper}>
                        {/* DMA */}
                        <div className={styles.dma}>
                            <Field label="DMA">
                                <div className="sda-select-firefox fa-angle-down">
                                    <Select
                                        name="designatedMarketArea"
                                        onChange={this.props.onChange}
                                        value={designatedMarketArea}>
                                        {data.designatedMarketAreas.map(dma => (
                                            <Option label={dma.dma_name} key={dma.dma_name} value={dma.dma_name} />
                                        ))}
                                    </Select>
                                </div>
                            </Field>
                        </div>
                        <div>
                            {/* CHANNEL  */}
                            <Field label="Channel">
                                <TextInput
                                    errorMessage={channel.errorMessage}
                                    name="channel"
                                    type="text"
                                    className="sda-input-text-full"
                                    value={channel.value}
                                    onChange={this.props.onValidatedInputChange}
                                    maxLength="10"
                                    placeholder="11"
                                />
                            </Field>
                        </div>
                    </div>
                    {/* PROD URL  */}
                    <Field label="Production URL">
                        <TextInput
                            errorMessage={url.errorMessage}
                            name="production-url"
                            type="text"
                            className="sda-input-text-full"
                            value={url.value}
                            onBlur={this.props.onProdUrlBlur}
                            onChange={this.props.onUrlChange}
                            maxLength="256"
                            placeholder="foxbaltimore.com"
                        />
                    </Field>

                    {/* STAGING URL  */}
                    <Field label="Staging URL">
                        <TextInput
                            readOnly
                            disabled
                            name="stagingUrl"
                            type="text"
                            className="sda-input-text-full"
                            value={stagingUrl}
                            onChange={this.props.onUrlChange}
                            maxLength="256"
                            placeholder="foxbaltimore.sinclairlive.com"
                        />
                    </Field>

                    {/* FOOTER TEXT  */}
                    <Field label="Footer Text">
                        <Textarea
                            errorMessage={footerText.errorMessage}
                            name="footerText"
                            type="text"
                            className="sda-textarea-full"
                            maxLength="2048"
                            onChange={this.props.onValidatedInputChange}
                            placeholder="Footer text"
                            value={footerText.value}
                        />
                    </Field>
                </div>
                <div className={styles.columnRight}>
                    {/* INTERNAL LOGO IMAGE  */}
                    <Field label="StoryLine Image">
                        <ImageUploader
                            imageUrl={imageUrl}
                            label="Logo"
                            name="logoImage"
                            uploadImage={this.props.onImageUpload}
                        />
                    </Field>
                </div>
            </div>
        );
    }
}

export default GeneralSettings;
